import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

import SampleCardsImgBlue from 'assets/images/unlimitedCard/renew/sample_cards-blue.png'
import SampleCardsImgRed from 'assets/images/unlimitedCard/renew/sample_cards-red.png'
import SampleCardsBgImg from 'assets/images/unlimitedCard/renew/sample_cards_bg.jpg'
import Box from 'components/shared/Box'
import { CardEditionType } from 'store/api-slice/types'

interface ImageWrapperProps {
    cardEdition: CardEditionType
    alt: string
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
    height: 180px;
    width: 100%;
    border-radius: 8px;
    background-image: ${({ cardEdition }) =>
        cardEdition === 'red'
            ? `url(${SampleCardsImgRed}), url(${SampleCardsBgImg})`
            : `url(${SampleCardsImgBlue}), url(${SampleCardsBgImg})`};
    background-size: auto 85%, cover;
    background-repeat: no-repeat;
    background-position: 45%, center;

    @media ${respondAbove.md} {
        height: 286px;
    }
`

export const Wrapper = styled(Box)`
    br {
        display: none;

        @media ${respondAbove.md} {
            display: inline;
        }
    }
`
